import React from "react";
import { SvgBlock as SvgBlockType, SvgPath } from "../types";

function SvgBlock({ block }: { block: SvgBlockType }) {
  const data = JSON.parse(block.value || "{}");
  if (!data.paths || !data.viewBox) return null;
  return (
    <>
      <svg
        style={{
          position: "absolute",
          left: 0,
          top: 0,
          width: "100%",
          height: "100%",
        }}
        viewBox={data.viewBox.join(" ")}
      >
        {data.paths.map((path: SvgPath, i: number) => (
          <path
            style={{ pointerEvents: "auto" }}
            key={i}
            data-cursor={"grab"}
            d={path.d}
            fill={path.fill}
            strokeWidth={12}
            stroke={"transparent"}
          />
        ))}
      </svg>
    </>
  );
}

export default SvgBlock;
